<template>
  <div>
    <section>
      <div class="wp1200">
        <div class="onBoardRegistration padd">
          <hr class="blue" />
          <h4>Število članov gospodinjstva</h4>
          <ul class="numOfMembers">
            <li>
              <span class="labelTxt">Polnoletne osebe</span>
              <div class="value flex">
                <span class="warpit_icon_MINUS icon"></span>
                <span class="num">1</span>
                <span class="warpit_icon_plus icon"></span>
              </div>
            </li>
            <li>
              <span class="labelTxt">Mladoletne osebe</span>
              <div class="value flex">
                <span class="warpit_icon_MINUS icon"></span>
                <span class="num">1</span>
                <span class="warpit_icon_plus icon"></span>
              </div>
            </li>
          </ul>
          <div class="next flex">
            <a class="txt" href="#">Prejšnji korak</a>
            <a
              class="join smallFont hoverEffect"
              href="https://studiolev.si/warp-panel/on_board_registration_finished.html"
            >
              <label>Naslednji korak</label>
              <span class="effect"></span>
              <img src="@/assets/images/nextArrowAnimation.svg" />
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      notCompleted: true,
    };
  },
  components: {},
  mounted() {},
  methods: {},
};
</script>
<style>
</style>